// src/pages/ManageTemplatesPage.js
import React, { useState } from 'react';
import Header from '../components/Header';
import TemplateForm from '../components/TemplateForm';
import TemplateList from '../components/TemplateList';

const ManageTemplatesPage = () => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const handleEdit = (template) => {
    setSelectedTemplate(template);
  };

  const handleSave = () => {
    setSelectedTemplate(null);
  };

  return (
    <div>
      <Header title="Manage Templates" />
      <div style={{ padding: 16, marginTop: 24 }}>
        {selectedTemplate ? (
          <TemplateForm template={selectedTemplate} onSave={handleSave} />
        ) : (
          <TemplateList onEdit={handleEdit} />
        )}
      </div>
    </div>
  );
};

export default ManageTemplatesPage;
